const cardItems = [
  {
    title: '某女星被拍到深夜与神秘男子同返公寓，经纪人回应引热议',
    desc: '当晚被粉丝偶遇后照片迅速流传，男方身份被扒出后评论区瞬间沦陷。',
    tag: '明星恋情',
    img: 'https://readdy.ai/api/search-image?query=A%20stylized%20editorial%20illustration%20of%20celebrity%20dating%20rumor%20and%20paparazzi%20style%20scene%2C%20warm%20coral%20and%20amber%20tones%2C%20abstract%20silhouette%20shapes%2C%20modern%20magazine%20layout%20with%20dramatic%20yet%20sophisticated%20composition&width=600&height=400&seq=card-01-51cg&orientation=landscape',
  },
  {
    title: '品牌代言人突然解约，品牌方发布声明暗藏玄机',
    desc: '解约公告中"双方友好协商"的表述引发猜测，业内人透露真实原因并不简单。',
    tag: '品牌翻车',
    img: 'https://readdy.ai/api/search-image?query=A%20sophisticated%20visual%20of%20brand%20endorsement%20termination%20and%20PR%20announcement%2C%20warm%20amber%20color%20scheme%2C%20abstract%20contract%20and%20document%20shapes%2C%20editorial%20design%20with%20clean%20professional%20aesthetic&width=600&height=400&seq=card-02-51cg&orientation=landscape',
  },
  {
    title: '综艺节目录制现场突发冲突，节目组紧急叫停',
    desc: '据现场观众爆料，两位嘉宾因观点分歧爆发激烈争执，场面一度失控。',
    tag: '综艺翻车',
    img: 'https://readdy.ai/api/search-image?query=A%20stylized%20illustration%20of%20variety%20show%20studio%20conflict%20and%20dramatic%20tension%2C%20warm%20coral%20gradients%2C%20abstract%20stage%20and%20spotlight%20shapes%2C%20modern%20editorial%20design%20with%20dynamic%20yet%20sophisticated%20composition&width=600&height=400&seq=card-03-51cg&orientation=landscape',
  },
  {
    title: '网红直播带货数据造假被实锤，平台连夜封禁',
    desc: '第三方监测机构发布报告后引发行业震动，多个头部主播数据遭质疑。',
    tag: '网红翻车',
    img: 'https://readdy.ai/api/search-image?query=A%20sophisticated%20editorial%20visual%20of%20live%20streaming%20ecommerce%20data%20fraud%20exposed%2C%20warm%20amber%20and%20coral%20color%20palette%2C%20abstract%20chart%20and%20graph%20shapes%2C%20modern%20magazine%20style%20with%20clean%20composition&width=600&height=400&seq=card-04-51cg&orientation=landscape',
  },
  {
    title: '某导演新片选角争议持续发酵，粉丝联合抵制',
    desc: '选角消息公布后话题迅速登顶热搜，导演社交账号评论区被粉丝刷屏。',
    tag: '影视争议',
    img: 'https://readdy.ai/api/search-image?query=A%20stylized%20illustration%20of%20film%20casting%20controversy%20and%20fan%20protest%2C%20warm%20coral%20tones%2C%20abstract%20film%20reel%20and%20protest%20shapes%2C%20editorial%20design%20with%20dramatic%20yet%20sophisticated%20aesthetic&width=600&height=400&seq=card-05-51cg&orientation=landscape',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="flex items-center justify-between mb-2">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
              深度爆料
            </h2>
            <a
              href="#"
              className="text-sm text-primary-600 hover:text-primary-700 flex items-center gap-1 whitespace-nowrap cursor-pointer"
            >
              更多 <i className="ri-arrow-right-line"></i>
            </a>
          </div>
          <p className="text-sm text-foreground-600 mb-8">
            全网最新最热吃瓜爆料，一手掌握
          </p>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 md:gap-5">
            {cardItems.map((item) => (
              <div
                key={item.title}
                className="group bg-background-100 rounded-xl overflow-hidden cursor-pointer hover:bg-background-100/80 transition-colors"
              >
                <div className="relative aspect-[4/3] overflow-hidden">
                  <img
                    src={item.img}
                    alt={item.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                  <span className="absolute top-2 left-2 bg-primary-500 text-white text-[10px] px-2 py-0.5 rounded font-medium">
                    {item.tag}
                  </span>
                </div>
                <div className="p-3 md:p-4">
                  <h3 className="text-sm font-medium text-foreground-900 line-clamp-2 leading-relaxed mb-2">
                    {item.title}
                  </h3>
                  <p className="text-xs text-foreground-600 leading-relaxed line-clamp-2">
                    {item.desc}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}